const TermsAndConditions = () => {
    return (
        <div>
            <h1>Terms and Conditions</h1>
            <p>Here you can put your terms and conditions content.</p>
        </div>
    );
};

export default TermsAndConditions;